import React from "react";

import {FIELD_TYPE, tabKeys, TT_PHIEU_VTYT} from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import {ColumnProps} from "../../../../../types/models";
import {listGender} from "../../../../../data/list";
import dayjs from "dayjs";
import {trangThaiPKOptions} from "../../../../../assets/constants/select-catagory-options";

const { INPUT, DATE,DATE_DISABLE_NO_DAY, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER } = FIELD_TYPE;

const listStatus = [
  {
    value: 0,
    label: "Đăng ký",
  },
  {
    value: 1,
    label: "Đã trúng tuyển",
  },
  {
    value: 2,
    label: "Không trúng tuyển",
  },
  {
    value: 3,
    label: "Tiềm năng",
  },
];

const  allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    align:"center",
    width:  140,
    isResizable: true,
    
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    isResizable: true,
    align: 'left',
    fixed:"left",
  },
  {
    title: "Ngày sinh",
    key: "ngaySinhDto",
    show: true,
    dataIndex: "ngaySinhDto",
    isResizable: true,
    align: 'center',
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    show: true,
    dataIndex: "gioiTinh",
    render(value, record, index) {
      return <>{value === 0 ? "Nam" : "Nữ"}</>;
    },
    align: 'center',
    isResizable: true,
  },
  {
    title: "Ngày phỏng vấn",
    key: "ngayPhongVan",
    show: true,
    dataIndex: "ngayPhongVan",
    isResizable: true,
    align: 'center',
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : "_" ,
  },
  {
    title: "Di động",
    key: "dienThoaiDiDong",
    show: true,
    dataIndex: "dienThoaiDiDong",
    isResizable: true,
    align: 'center',
  },
  {
    title: "Tốt nghiệp trường",
    key: "totNghiepTruong",
    show: true,
    dataIndex: "totNghiepTruong",
    isResizable: true,
    align: 'left',
  },
  {
    title: "Trình độ",
    key: "trinhDo",
    show: true,
    dataIndex: "trinhDo",
    isResizable: true,
    align: 'left',
  },
  {
    title: "Xếp loại",
    key: "xepLoai",
    show: true,
    dataIndex: "xepLoai",
    isResizable: true,
    align: 'left',
  },
  {
    title: "Trạng thái",
    key: "trangThai",
    show: true,
    dataIndex: "trangThai",
    render: (v, r, i) =>
        listStatus.find(it => it.value === v)?.label || "",
    align: 'left',
    isResizable: true,
  },
  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    show: true,
    width: 150,
    align: "center",
    fixed: "right",
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: INPUT,
    name: "hoTen",
    label: "Họ tên",
   
  },

  {
    type: COMBO_BOX,
    name: "gioiTinh",
   
    label: "Giới tính",
    options: listGender,
  },

  {
    type: COMBO_BOX,
    name: "viTriUngTuyen",
    label: "Vị trí ứng tuyển",
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "ngayPhongVanTu",
    disableDate: false,
    label: "Ngày phỏng vấn từ",
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "ngayPhongVanDen",
    disableDate: false,
    label: "Ngày phỏng vấn đến",
  },
  {
    type: COMBO_BOX,
    name: "trangThai",
   
    label: "Trạng thái",
    options: listStatus,
  },

];

export { allColumns, itemsInputField };
